import React from "react";
import containerStyles from "../WidgetContainer/WidgetContainer.module.css";
import s from "./ImagePreview.module.css";

const ImagePreview = ({ previewUrl, onClick, isMobile }) => {
  if (!previewUrl) return null;

  return (
    <div
      className={`${containerStyles.imagePreviewContainer} ${s.imagePreviewContainer}`}
      onClick={onClick}
    >
      <img
        className={containerStyles.personImage}
        src={previewUrl}
        alt="upload image preview"
      />
      <div className={containerStyles.uploadOverlay}>Заменить</div>
    </div>
  );
};

export default ImagePreview;
